import {useEffect, useState} from 'react'
import {useNavigate, useLocation, useParams} from 'react-router-dom'
// routes
import AppRoute from './routes'
// theme
import ThemeConfig from './theme'
import CloseIcon from '@mui/icons-material/Close'
// components
// import Settings from './components/settings';
import RtlLayout from './components/RtlLayout'
import ScrollToTop from './components/ScrollToTop'
import NotistackProvider from './components/NotistackProvider'
import ThemePrimaryColor from './components/ThemePrimaryColor'
import ThemeLocalization from './components/ThemeLocalization'
import {MainProvider} from './utils/context/main'
import {UsersProvider} from './utils/context/users'
// import { SocketProvider } from './utils/context/socket'
import {WorkmateTimeinProvider} from './utils/context/workmateTimein'
import useNetworkSpeedCheck from './utils/hooks/useNetworkSpeedCheck'
import SessionAuth from './components/SessionAuth'
import {Dialog, DialogActions, DialogContent, Button, DialogTitle, Typography, IconButton} from '@material-ui/core'
// ----------------------------------------------------------------------

export default function App() {
  const [uiVersion, setUiVersion] = useState('old')
  const [showVersionModal, setShowVersionModal] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const {open, message, setOpen} = useNetworkSpeedCheck()
  const location = useLocation()

  // Mobile detection
  useEffect(() => {
    const checkIsMobile = () => {
      const width = window.innerWidth
      const height = window.innerHeight
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      const isMobileWidth = width < 768
      const isMobileHeight = height < 600
      const isLikelyMobile = isMobileWidth || (hasTouchScreen && width < 1024)

      console.log('Device check:', {
        width,
        height,
        hasTouchScreen,
        isMobileWidth,
        isMobileHeight,
        isLikelyMobile,
        userAgent: navigator.userAgent.toLowerCase()
      })

      setIsMobile(isLikelyMobile)
    }

    checkIsMobile()
    window.addEventListener('resize', checkIsMobile)

    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  // load saved version from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('uiVersion')

    // Mobile devices should always use old design
    if (isMobile) {
      if (saved === 'new') {
        console.log('Mobile user detected with new version, switching to old version')
        localStorage.setItem('uiVersion', 'old')
        setUiVersion('old')
      } else {
        setUiVersion(saved || 'old')
      }
      setShowVersionModal(false)
      return
    }

    // Desktop logic - allow version selection
    if (saved) {
      setUiVersion(saved)
      if (saved === 'old' && location.pathname === '/login') {
        setShowVersionModal(true)
      }
    } else if (location.pathname === '/login') {
      setShowVersionModal(true)
    }
  }, [location.pathname, isMobile])

  // Handle device type changes (desktop <-> mobile)
  useEffect(() => {
    const currentVersion = localStorage.getItem('uiVersion')

    if (isMobile) {
      // Mobile: force old version
      if (currentVersion === 'new') {
        console.log('Device changed to mobile, switching to old version')
        localStorage.setItem('uiVersion', 'old')
        setUiVersion('old')
      }
      setShowVersionModal(false)
    }
  }, [isMobile])

  useEffect(() => {
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = 'auto'
    }
  })

  const handleSelectVersion = (version) => {
    localStorage.setItem('uiVersion', version)
    setUiVersion(version)
    setShowVersionModal(false)
  }
  const handleClose = () => {
    setShowVersionModal(false)
  }
  return (
    <>
      {/* Version selection modal */}
      <Dialog
        open={showVersionModal}
        onClose={handleClose}
        PaperProps={{
          sx: {
            position: 'absolute',
            top: 24,
            left: 24,
            margin: 0,
            borderRadius: 2,
            width: 360,
          },
        }}
      >
        {/* Close (X) fixed top-right */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary',
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle sx={{fontWeight: 'bold', fontSize: 15}}>✨ New Sparkle Time Keeping is Here!</DialogTitle>

        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            We’ve upgraded the design to give you a smoother, faster, and more intuitive experience. Would you like to
            try the new version now?
          </Typography>
        </DialogContent>

        <DialogActions sx={{justifyContent: 'flex-end'}}>
          <Button onClick={() => handleSelectVersion('new')} color="primary" sx={{textTransform: 'none'}}>
            Try the New Design
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Network Alert
          </Typography>
        </DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <ThemeConfig>
        <ThemePrimaryColor>
          <ThemeLocalization>
            <MainProvider>
              <UsersProvider>
                {/*<SocketProvider>*/}
                <WorkmateTimeinProvider>
                  <RtlLayout>
                    <NotistackProvider>
                      <ScrollToTop />
                      <SessionAuth>
                        <AppRoute />
                      </SessionAuth>
                    </NotistackProvider>
                  </RtlLayout>
                </WorkmateTimeinProvider>
                {/*</SocketProvider>*/}
              </UsersProvider>
            </MainProvider>
          </ThemeLocalization>
        </ThemePrimaryColor>
      </ThemeConfig>
    </>
  )
}
